<template lang="pug">
    v-dialog(v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition" )
        template
            v-toolbar(dark dense color="red" class="navFixed")
                v-toolbar-title i-Permit Preview
                v-spacer
                v-toolbar-title(v-if="![10,11].includes(ip.ipStatus) && getApproveStatus(ip.ipWorkflow) == '7'") Approved on {{formatDate(getApproveDate(ip.ipWorkflow))}}
                v-toolbar-title(v-else-if="getApproveStatus(ip.ipWorkflow) == '8'") Rejected on {{formatDate(getApproveDate(ip.ipWorkflow))}}
                v-toolbar-items
                    v-btn(v-if="dialogType !== 'creator' && isCurrentApprover()" @click.stop="approvalDialog = true" color="red" depressed title='Approval' class="blink") 
                        v-icon(title="Approval") assignment_turned_in
                        | &nbsp; Approval
                    v-dialog(v-if="dialogType !== 'creator' && isCurrentApprover()" v-model="approvalDialog" persistent max-width="500px")
                        v-card()
                            v-card-title(class="headline grey lighten-2") Approval Form
                            v-card-text
                                v-layout(wrap)
                                    v-flex(xs12)
                                        v-radio-group(v-model="approval" row)
                                            v-radio(label="Approve" color="success" value="7")
                                            v-radio(v-if="ip.ipStatus !== 10" label="Reject" color="red" value="8")
                                            v-radio(v-if="ip.ipStatus == 10" label="Need Review" color="yellow darken-4" value="11")
                                            v-radio(v-else label="Need Review" color="yellow darken-4" value="3")
                                            
                                    v-flex(xs12)
                                        v-textarea(
                                            v-model="comment"
                                            filled
                                            label="Comment (Optional)"
                                            value=""
                                        )
                            v-card-actions
                                v-spacer
                                v-btn(text @click.native="approvalDialog = false") Close
                                v-btn(:disabled="!approval" text :loading="approvalDialog2" color="blue darken-1" @click="approvalDialog2 = true") Submit
                                v-dialog(
                                    v-model="approvalDialog2"
                                    hide-overlay
                                    persistent
                                    width="300")
                                    v-card(color="primary" dark)
                                    v-card-text Processing. Please wait!
                                        v-progress-linear(indeterminate color="white" class="mb-0")
                    v-btn(v-if="this.ip.ipStatus == 4 || this.ip.ipStatus == 8" @click="shareIP();" color="red" depressed title="Share" )
                        v-icon share
                        | &nbsp; Share
                        v-dialog(v-model="share" persistent max-width="400px")
                            v-card
                                v-card-title(class="headline grey lighten-3") Share
                                v-flex(class="headline grey lighten-3")
                                    v-row(no-gutters align="center" justify="center")
                                        ShareNetwork(
                                            v-for="network in networks"
                                            :key="network.key"
                                            class="ma-3 pa-3 green"
                                            :network="network.network"
                                            style="border-radius: 10px; box-shadow: -2px 4px #888888;"
                                            :url="shortenUrl"
                                            :title="sharing.title"
                                            :description="sharing.description"
                                        ) 
                                            i(:class="network.icon" style="color:white")
                                            span(class="ma-3" style="color:white") {{ network.name }}
                                v-spacer
                                v-flex(class="text-end headline grey lighten-2")
                                    v-btn(color="blue darken-1" text @click.native="share = false") Close
                    v-btn(@click="ip.ipStatus == 4 || ip.ipStatus == 8 ? print = true : printIP(ip._id)" color="red" depressed title="Print" )
                        v-icon print
                        | &nbsp; Print
                        v-dialog(v-model="print" persistent max-width="400px")
                            v-card
                                v-card-title(class="headline grey lighten-3") Print Document
                                v-alert(:value='true' color="success")
                                    h3(style="text-align: center; font-weight:normal; color: white;") To save the trees, please think to share it rather than print.
                                v-flex(class="headline grey lighten-3")
                                    v-row(no-gutters align="center" justify="center")
                                        v-btn(@click="printIP(ip._id); print = false;" class="ma-3 pa-3 red darken-2" style="border-radius: 10px; box-shadow: -2px 4px #888888;")
                                            i(class="far fah fa-lg fa fa-print" style="color:white")
                                            span(class="ma-3" style="color:white") Print
                                        v-btn(@click="print = false; shareIP();" class="ma-3 pa-3 green" style="border-radius: 10px; box-shadow: -2px 4px #888888;")
                                            i(class="far fah fa-lg fa fa-share-alt" style="color:white")
                                            span(class="ma-3" style="color:white") Share
                                v-spacer
                                v-flex(class="text-end headline grey lighten-2")
                                    v-btn(color="blue darken-1" text @click.native="print = false") Close
                    v-btn(@click.native="dialog = false" color="red" depressed)
                        v-icon(title="Close") cancel
                        | &nbsp; Close
            div(:id="ip._id")
                v-list(class="print-bg padTop60")
                    div()
                        .page(size="Auto")
                            div(class="view-width" style="font-size:11px;")
                                div(v-if="ip.ipStatus == 4" id="background")
                                    p(class="fontWatermarkUp" ) {{ip.ipNo}}
                                    img(src="../assets/Approve.png" class="imgWatermark")
                                    p(class="fontWatermarkDown" ) {{ip.ipNo}}
                                div(v-else-if="ip.ipStatus == 8" id="background")
                                    p(class="fontWatermarkUp" ) {{ip.ipNo}}
                                    img(src="../assets/reject.png" class="imgWatermark")
                                    p(class="fontWatermarkDown" ) {{ip.ipNo}}
                                div(v-else-if="ip.ipStatus == 13" id="background")
                                    p(class="fontWatermarkUp" ) {{ip.ipNo}}
                                    img(src="../assets/Auto Canceled.png" class="imgWatermark")
                                    p(class="fontWatermarkDown" ) {{ip.ipNo}}
                                div(v-else-if="ip.ipStatus == 14" id="background")
                                    p(class="fontWatermarkUp" ) {{ip.ipNo}}
                                    img(src="../assets/Auto Rejected.png" class="imgWatermark")
                                    p(class="fontWatermarkDown" ) {{ip.ipNo}}
                                div(v-else-if="ip.ipStatus == 15" id="background")
                                    p(class="fontWatermarkUp" ) {{ip.ipNo}}
                                    img(src="../assets/Auto Dropped.png" class="imgWatermark")
                                    p(class="fontWatermarkDown" ) {{ip.ipNo}}
                                div(v-else-if="ip.ipStatus == 12" id="background")
                                    p(class="fontWatermarkUp" ) {{ip.ipNo}}
                                    img(src="../assets/Done.png" class="imgWatermark")
                                    p(class="fontWatermarkDown" ) {{ip.ipNo}}
                                table(class="view-width tableInput" style="margin-top:10px;")
                                    tbody
                                        tr
                                            td( class="align-center" width="150" rowspan="3")
                                                img(class="verMiddle" src="../assets/BORNEO-INDOBARA.jpg" width="120px")
                                            td(class="align-center") SINARMAS MINING SYSTEM
                                            td( class="align-center" width="150" rowspan="3") 
                                                img(class="verMiddle" :src="`${API_URL}/qr/generate/?ipNo=${ip.ipNo}&formCode=${ip.ipForm}`" style="width:80px;margin:2px 0;")
                                        tr
                                            td(class="align-center") FORMULIR
                                        tr
                                            td(class="align-center") {{ formName[ip.ipForm] }}
                                div(style="text-align:center;padding:10px;margin-bottom:-10px;font-style: italic")
                                    label Formulir ini  digunakan untuk  dokumentasi, penerapan dan pengesahan perubahan yang diajukan
                                
                                table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                                    thead
                                        tr
                                            td(class="headerTable" width="150" colspan="7") A. Detail Usulan
                                    tbody(style="border: 1px solid black")
                                        
                                        tr
                                            td(width="150" class="headerTable") Judul Usulan
                                            td(colspan="3") {{ ip.ipJudulPekerjaan }}
                                        tr
                                            td(class="headerTable") No Registrasi
                                            td(width="250") {{ ip.ipNo }}
                                            td(width="100" class="headerTable") Tanggal
                                            td {{dayjs(ip.ipTanggalPerubahan).format(dateFormat)}}
                                        tr
                                            td(class="headerTable") Pengaju
                                            td(width="250") {{ ip ? (ip.ipPemegangIzin ? ip.ipPemegangIzin.name : "") : "" }}
                                            td(width="100" class="headerTable") Jabatan
                                            td {{ ip ? (ip.ipPemegangIzin ? ip.ipPemegangIzin.title : "") : "" }}
                                        tr
                                            td(class="headerTable") Department / Divisi
                                            td(width="250") {{ ip.ipDeptDivisi }} / {{ ip.ipDivisi }}
                                            td(width="100" class="headerTable") Perusahaan
                                            td {{ip.ipPerusahaan}}
                                
                                table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                                    tbody
                                        tr
                                            td(class=" headerTable" width="150" colspan="8") B. Klasifikasi Umum Perubahan
                                        tr
                                            td(width="5" class="align-center" style="padding:5px")
                                                img(v-if="ip.ipKlasifikasiUmum && ip.ipKlasifikasiUmum[0] && ip.ipKlasifikasiUmum[0].selected == true" class="verMiddle" src="../assets/check-blue.png" width="13") 
                                                img(v-else src="../assets/uncheck.png" width="13" style="margin:2px 5px -2px 4px") 
                                            td(width="125") Jenis Peralatan
                                            td(width="5" class="align-center" style="padding:5px")
                                                img(v-if="ip.ipKlasifikasiUmum && ip.ipKlasifikasiUmum[1] && ip.ipKlasifikasiUmum[1].selected == true" class="verMiddle" src="../assets/check-blue.png" width="13") 
                                                img(v-else src="../assets/uncheck.png" width="13" style="margin:2px 5px -2px 4px")  
                                            td(width="125") Lokasi Aktivitas
                                            td(width="5" class="align-center" style="padding:5px")
                                                img(v-if="ip.ipKlasifikasiUmum && ip.ipKlasifikasiUmum[2] && ip.ipKlasifikasiUmum[2].selected == true" class="verMiddle" src="../assets/check-blue.png" width="13") 
                                                img(v-else src="../assets/uncheck.png" width="13" style="margin:2px 5px -2px 4px")  
                                            td(width="125") Nomor Peralatan
                                            td(width="5" class="align-center" style="padding:5px")
                                                img(v-if="ip.ipKlasifikasiUmum && ip.ipKlasifikasiUmum[3] && ip.ipKlasifikasiUmum[3].selected == true" class="verMiddle" src="../assets/check-blue.png" width="13") 
                                                img(v-else src="../assets/uncheck.png" width="13" style="margin:2px 5px -2px 4px")  
                                            td(width="125") Organisasi
                                        tr
                                            td(width="5" class="align-center" style="padding:5px")
                                                img(v-if="ip.ipKlasifikasiUmum && ip.ipKlasifikasiUmum[4] && ip.ipKlasifikasiUmum[4].selected == true" class="verMiddle" src="../assets/check-blue.png" width="13") 
                                                img(v-else src="../assets/uncheck.png" width="13" style="margin:2px 5px -2px 4px")  
                                            td(width="125") Prosedur
                                            td(width="5" class="align-center" style="padding:5px")
                                                img(v-if="ip.ipKlasifikasiUmum && ip.ipKlasifikasiUmum[5] && ip.ipKlasifikasiUmum[5].selected == true" class="verMiddle" src="../assets/check-blue.png" width="13") 
                                                img(v-else src="../assets/uncheck.png" width="13" style="margin:2px 5px -2px 4px")  
                                            td(width="125") Perangkat Lunak
                                            td(width="5" class="align-center" style="padding:5px")
                                                img(v-if="ip.ipKlasifikasiUmum && ip.ipKlasifikasiUmum[6] && ip.ipKlasifikasiUmum[6].selected == true" class="verMiddle" src="../assets/check-blue.png" width="13") 
                                                img(v-else src="../assets/uncheck.png" width="13" style="margin:2px 5px -2px 4px")  
                                            td(width="125") Proses
                                            td(width="5" class="align-center" style="padding:5px")
                                                img(v-if="ip.ipKlasifikasiUmum && ip.ipKlasifikasiUmum[7] && ip.ipKlasifikasiUmum[7].selected == true" class="verMiddle" src="../assets/check-blue.png" width="13") 
                                                img(v-else src="../assets/uncheck.png" width="13" style="margin:2px 5px -2px 4px")  
                                            td(width="125") Rencana Tambang
                                        tr
                                            td(width="5" class="align-center" style="padding:5px")
                                                img(v-if="ip.ipKlasifikasiUmum && ip.ipKlasifikasiUmum[8] && ip.ipKlasifikasiUmum[8].selected == true" class="verMiddle" src="../assets/check-blue.png" width="13") 
                                                img(v-else src="../assets/uncheck.png" width="13" style="margin:2px 5px -2px 4px")  
                                            td(width="125") Tata Letak
                                            td(width="5" class="align-center" style="padding:5px")
                                                img(v-if="ip.ipKlasifikasiUmum && ip.ipKlasifikasiUmum[9] && ip.ipKlasifikasiUmum[9].selected == true" class="verMiddle" src="../assets/check-blue.png" width="13") 
                                                img(v-else src="../assets/uncheck.png" width="13" style="margin:2px 5px -2px 4px")  
                                            td(width="125") Desain & Konstruksi
                                            td(width="5" class="align-center" style="padding:5px")
                                                img(v-if="ip.ipKlasifikasiUmum && ip.ipKlasifikasiUmum[10] && ip.ipKlasifikasiUmum[10].selected == true" class="verMiddle" src="../assets/check-blue.png" width="13") 
                                                img(v-else src="../assets/uncheck.png" width="13" style="margin:2px 5px -2px 4px")  
                                            td(width="125") Perubahan Jalan
                                            td(width="5" class="align-center" style="padding:5px")
                                                img(v-if="ip.ipKlasifikasiUmum && ip.ipKlasifikasiUmum[11] && ip.ipKlasifikasiUmum[11].selected == true" class="verMiddle" src="../assets/check-blue.png" width="13") 
                                                img(v-else src="../assets/uncheck.png" width="13" style="margin:2px 5px -2px 4px")  
                                            td(width="125") Bahan Berbahaya  
                                            

                                table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                                    tbody
                                        tr
                                            td(class=" headerTable" width="150" colspan="8") C. Rincian Usulan Perubahan
                                        tr(v-for="(item, index) in ip.ipRincianUsulan" :key="index")
                                            td(width="5" class="align-center" style="padding:5px") 
                                                img(v-if="item.selected == true" class="verMiddle" src="../assets/check-blue.png" width="13") 
                                                img(v-else src="../assets/uncheck.png" width="13" style="margin:2px 0px -2px 0px")
                                            td(width="150") {{item.label}}
                                            td(width="400") {{item.description}}
                                                      
                                table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                                    tbody
                                        tr
                                            td(class=" headerTable" width="150" colspan="8") C.i Latar Belakang Perubahan
                                        tr
                                            td 
                                                div(v-html="ip.ipLatarBelakang" class="ck-content")
                                
                                table( class="view-width tableInput autoPageBreak" style="margin-top:10px")
                                    tbody
                                        tr
                                            td(class=" headerTable" width="50") Lampiran
                                            td( width="90") 
                                                img(v-if="ip.ipLatarBelakangLampiran && ip.ipLatarBelakangLampiran.docPendukung" src="../assets/check-blue.png" width="13" style="margin:2px 5px -2px 2px")
                                                img(v-else src="../assets/uncheck.png" width="13" style="margin:2px 5px -2px 2px")  
                                                span Ya
                                                img(v-if="ip.ipLatarBelakangLampiran && ip.ipLatarBelakangLampiran.docPendukung" src="../assets/uncheck.png" width="13" style="margin:2px 5px -2px 20px")
                                                img(v-else src="../assets/check-blue.png" width="13" style="margin:2px 5px -2px 20px") 
                                                span Tidak
                                            td(class=" headerTable" width="80") Judul Lampiran
                                            td(width="250") {{ ip.ipLatarBelakangLampiran ? getNameFile(ip.ipLatarBelakangLampiran.docPendukung) : "" }}
                                            td(class=" headerTable" width="30") File
                                            td(width="50" style="padding:3px") 
                                                img(v-if="ip.ipLatarBelakangLampiran && ip.ipLatarBelakangLampiran.docPendukung" class="verMiddle" src="../assets/file-import.png" width="12" style="margin-left:10px;cursor: pointer" @click="download(ip.ipLatarBelakangLampiran.docPendukung)")
                                                img(v-else class="verMiddle" src="../assets/close.png" width="12" style="margin-left:10px" )
                                table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                                    tbody
                                        tr
                                            td(class=" headerTable" width="150" colspan="8") C.ii Perubahan yang Diusulkan
                                        tr
                                            td 
                                                div(v-html="ip.ipPerubahanDiusulkan" class="ck-content")
                                
                                table( class="view-width tableInput autoPageBreak" style="margin-top:10px")
                                    tbody
                                        tr
                                            td(class=" headerTable" width="50") Lampiran
                                            td( width="90") 
                                                img(v-if="ip.ipPerubahanDiusulkanLampiran && ip.ipPerubahanDiusulkanLampiran.docPendukung" src="../assets/check-blue.png" width="13" style="margin:2px 5px -2px 2px")
                                                img(v-else src="../assets/uncheck.png" width="13" style="margin:2px 5px -2px 2px")  
                                                span Ya
                                                img(v-if="ip.ipPerubahanDiusulkanLampiran && ip.ipPerubahanDiusulkanLampiran.docPendukung" src="../assets/uncheck.png" width="13" style="margin:2px 5px -2px 20px")
                                                img(v-else src="../assets/check-blue.png" width="13" style="margin:2px 5px -2px 20px") 
                                                span Tidak
                                            td(class=" headerTable" width="80") Judul Lampiran
                                            td(width="250") {{ ip.ipPerubahanDiusulkanLampiran ? getNameFile(ip.ipPerubahanDiusulkanLampiran.docPendukung) : "" }}
                                            td(class=" headerTable" width="30") File
                                            td(width="50" style="padding:3px") 
                                                img(v-if="ip.ipPerubahanDiusulkanLampiran && ip.ipPerubahanDiusulkanLampiran.docPendukung" class="verMiddle" src="../assets/file-import.png" width="12" style="margin-left:10px;cursor: pointer" @click="download(ip.ipPerubahanDiusulkanLampiran.docPendukung)")
                                                img(v-else class="verMiddle" src="../assets/close.png" width="12" style="margin-left:10px" )

                                table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                                    tbody
                                        tr
                                            td(class=" headerTable" width="150" colspan="8") C.iii. Hasil yang Diharapkan
                                        tr(v-for="(item, index) in ip.ipHasilHarapan" :key="index")
                                            td(width="5" class="align-center" style="padding:5px") 
                                                img(v-if="item.selected == true" class="verMiddle" src="../assets/check-blue.png" width="13") 
                                                img(v-else src="../assets/uncheck.png" width="13" style="margin:2px 0px -2px 0px")
                                            td(width="150") {{item.label}}
                                            td(width="400") {{item.description}}
                                table( class="view-width  autoPageBreak" style="margin-top:10px;")
                                    tbody
                                        tr
                                            td(style="padding:0 10px 10px 10px")
                                                div(v-html="ip.ipHasilDescription" class="ck-content")
                                table( class="view-width tableInput autoPageBreak" style="margin-top:10px")
                                    tbody
                                        tr
                                            td(class=" headerTable" width="50") Lampiran
                                            td( width="90") 
                                                img(v-if="ip.ipHasilDescriptionLampiran && ip.ipHasilDescriptionLampiran.docPendukung" src="../assets/check-blue.png" width="13" style="margin:2px 5px -2px 2px")
                                                img(v-else src="../assets/uncheck.png" width="13" style="margin:2px 5px -2px 2px")  
                                                span Ya
                                                img(v-if="ip.ipHasilDescriptionLampiran && ip.ipHasilDescriptionLampiran.docPendukung" src="../assets/uncheck.png" width="13" style="margin:2px 5px -2px 20px")
                                                img(v-else src="../assets/check-blue.png" width="13" style="margin:2px 5px -2px 20px") 
                                                span Tidak
                                            td(class=" headerTable" width="80") Judul Lampiran
                                            td(width="250") {{ ip.ipHasilDescriptionLampiran ? getNameFile(ip.ipHasilDescriptionLampiran.docPendukung) : "" }}
                                            td(class=" headerTable" width="30") File
                                            td(width="50" style="padding:3px") 
                                                img(v-if="ip.ipHasilDescriptionLampiran && ip.ipHasilDescriptionLampiran.docPendukung" class="verMiddle" src="../assets/file-import.png" width="12" style="margin-left:10px;cursor: pointer" @click="download(ip.ipHasilDescriptionLampiran.docPendukung)")
                                                img(v-else class="verMiddle" src="../assets/close.png" width="12" style="margin-left:10px" )
                UsulanSecondView(:dialogType="dialogType", :ip="ip", :approvalUser="approvalUser" class="autoPageBreak")        
                UsulanthirdView(:dialogType="dialogType", :ip="ip", :approvalUser="approvalUser" class="autoPageBreak")



</template>

<script>
import axios from 'axios';
import * as config from "../config/index.json";
import { mapState } from 'vuex';
import printJS from 'print-js';
import dayJS from 'dayjs';
import UsulanSecondView from './UsulanSecondView.vue';
import UsulanthirdView from './UsulanthirdView.vue';
import helper from "../helper/index.js";

export default {
  name: 'UsulanPerubahanView',
  props: {
    dialogType: String,
    ip: Object,
    approvalUser: Object
  },
  components :{
    UsulanSecondView,
    UsulanthirdView
  },
  data: () => ({
    formName: config.FormName,
    config: config.default,
    dialog: false,
    regex: /\//gi,
    approvalDialog: false,
    approvalDialog2: false,
    comment: '',
    ipVisitors:[],
    ipPengesahanApproval : null,
    ipClosingResubmitted : null,
    ipClosingSubmitted : null,
    ipDocPengesahan : null,
    approval: null,
    share: false,
    print: false
  }),
  computed: {
    ...mapState(['API_URL', "networks", "sharing", "shortenUrl", 'dateFormat']),
    locations(){
        let temp = []
        for (const index in this.ip.ipLocation) {
            temp.push(this.ip.ipLocation[index].name)
        }
        return temp
    },
  },
  methods: {
    dayjs(val = undefined) {
        return dayJS(val);
    },
    download(file) {
        this.$downloadFile(file);
    },
    shareIP() {
        this.$store.dispatch("getShortenUrl", {ip: this.ip, 
        approvalUser: this.approvalUser, context: this.share}).then(() => {
            this.share = true;
        });
    },
    printIP(id){
        printJS({
            printable: id, 
            type: 'html',
            scanStyles: false,
            css: ["/stylesheets/main.css" ,"/stylesheets/approval.css", "/stylesheets/vuetify.min.css",  '/stylesheets/view.css', "/stylesheets/ck-content.css", "/stylesheets/custom.css"]
        });
    },
    formatDate: helper.formatDateOnly,
    getApproveStatus(wf){
        let status = 0;
        if (!wf) return status;

        for(let i=0;i<wf.length;i++){
            if(wf[i].nik == this.approvalUser.nik && !this.isCurrentApprover()){
                status=wf[i].status;
                break;
            }
        }
        return status;
    },
    getApproveDate(wf){
        let approvedWf = null;
        for(let i=0;i<wf.length;i++){
            if(wf[i].nik == this.approvalUser.nik){
                approvedWf=wf[i];
                break;
            }
        }
        return approvedWf.date;
    },
    isCurrentApprover(){
        return helper.isApprover(
            this.$store.getters.isAuthenticated,
            this.ip,
            this.approvalUser
        );
    },
    approvalTime(date){
        return new Date(date).toLocaleString('en-GB');
    },
    getNameFile(name) {
        if ( name ) {
            let newArr = name.split("-")
            newArr.shift()
            return newArr.join('-')
        }
    }
  },
  watch: {
    approvalDialog2 (val) {
            if (!val) return;
            const NewFormData = {
                ipNo : this.ip.ipNo,
                status : parseInt(this.approval),
                comment : this.comment,
                approvalUser : this.approvalUser
            }
            
            let URL_API = `${this.API_URL}/v1/requests/perubahan/approval`;
            
            if ( this.ip.ipStatus == 10 ) {
                URL_API = `${this.API_URL}/v1/pengesahan/approval`;
                NewFormData["formId"] = this.ip._id
                delete NewFormData.ipNo
            }

            const config = {
                method: "post",
                url: URL_API,
                headers: {"Authorization": `Bearer ${this.$store.state.token}`},
                data: NewFormData
            };
            axios(config).then(res => {
                // console.log(res)
            if (res.status == 200) {
                setTimeout(() => {
                    this.dialog2 = false;
                    this.dialog = false;
                    location.reload();
                },
                1000);
            }
        });
    }
  }
};
</script>
<style scoped>
.print-bg {
  background: rgb(204,204,204);
  padding-top: 10px;
}
.print-bg > div{
  text-align:center;
}
.page {
  background: white;
  display: block;
  margin: 5px auto;
  padding: 0.7cm 1cm 0.8cm;
  position: relative;
}
.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}
.page[size="Auto"] {
  width: auto;
  margin:0 auto;
  display:inline-block;
  text-align:initial;
}
.view-width {
  width: 19cm;
}
.print-header {
  border-collapse: collapse;
  text-align: right;
}
.padding-x-3 {
  padding:0 3px;
}
.padding-xy-5 {
  padding:2px;
}
.padding-xy-1 {
  padding:1px;
}
.margin-tl-5 {
  margin: 3px 5px 0 5px;
}
.margin-tl-10 {
  margin: 3px 10px 0 10px;
}
.margin-tl-25 {
  margin: 3px 15px 0 25px;
}
.logo-cell {
  padding:8px 5px 0px;
  width:35%;
}
.detail-wrap {
  margin-top: 5px;
}
.border-left-0 {
  border-left: 0;
}
.border-right-0 {
  border-right: 0;
}
.approved {
  text-align: center;
  padding:5px;
}
.ff0000 {
  color: #ff0000;
}
.align-center {
  text-align: center;
}
.align-left {
 align-items: left;
}
.width-20p {
  width:20%;
}
.width-25p {
  width:25%;
}
.height-40px {
  height: 40px;
}
.width-300px {
  width: 250px;
}
.top-align {
  vertical-align:top;
}
.navFixed {
  position: fixed;
  z-index: 9;
}
.padTop60 {
  padding-top:60px;
}
.blink {
	-webkit-animation: blink 2s steps(5, start) infinite;
  animation: blink 2s steps(5, start) infinite;
  color: #dddddd;
}
@-webkit-keyframes blink { to { color: #ffffff; }}
@keyframes blink { to { color: #ffffff; }}
@media print {
    
}
table {
  border-collapse: collapse;
}
.headerTable{
    border: 1px solid black; 
    background-color: #cccccc;
    font-weight: 600;
}
.tableInput td{
    border: 1px solid black;
    padding-left: 5px;
}
.verMiddle{
    vertical-align:middle;
}
.comment{
    word-break: break-all;
}
.tableCollapse td{
    border: 1px solid black;
    border-top: 0;
    padding-left: 5px;
}
.emptySign {
    width:25px;
}
#background {
  position:absolute;
  z-index:0;
  display:block;
  top:150px;
  left:0px;
  text-align: center;
  width: 100%;
}
.imgWatermark {
  width: 650px;
  position:absolute;
  top:0px;
  right:50px;
  opacity: 0.65;
}
.fontWatermarkUp {
  font-size:450%; 
  position:absolute;
  transform: rotate(-30deg);
  opacity: 0.65;  
  right: 200px;
  color: rgb(224,224,224);
}
.fontWatermarkDown {
  font-size:450%; 
  position:absolute;
  transform: rotate(-30deg);
  opacity: 0.65;  
  top: 450px;
  right: 100px;
  color: rgb(224,224,224);
}
</style>